module.exports = __webpack_public_path__ + "img/jiahao.234682ab.png";